import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import {
  Nav,
} from 'reactstrap';

import ProfileMenu from '../../ProfileMenu';
import SwitchAccountSwitch from '../../SwitchAccountSwitch';

const AdminPanelSidebarNavigation = ({ profile }) => {
  const [expanded, setExpanded] = useState(false);

  if (!profile) {
    return null;
  }

  return (
    <div className={classnames('sidebar-navigation', { expanded })}>
      <div className="sidebar-navigation-top">
        <Nav className="ml-auto" navbar>
          <SwitchAccountSwitch />
        </Nav>
      </div>
      <div className="sidebar-navigation-bottom">
        <a
          className="expand-icon"
          href="#expand"
          onClick={(e) => {
            e.preventDefault();
            setExpanded(!expanded);
          }}
        >
          {expanded ? (
            <i className="far fa-chevron-up" />
          ) : (
            <i className="far fa-chevron-down" />
          )}
        </a>
        <Nav className="ml-auto" navbar>
          <ProfileMenu inAdminPanel={true} />
        </Nav>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

AdminPanelSidebarNavigation.propTypes = {
  profile: PropTypes.object,
};

AdminPanelSidebarNavigation.defaultProps = {
  profile: null,
};

export default connect(mapStateToProps)(AdminPanelSidebarNavigation);
